export default {
  errorMessage: "To polje je obvezno",
  errorEmail: "Vstavite veljaveno e-pošto",
};
